// extracted by mini-css-extract-plugin
export default {"button":"ButtonWithHoverEffect_button__dGR6i"};